import Api from '../../Api';

export const getLedgerStart = () => ({
    type:"GET_LEDGER_START"
})

export const getLedgerSuccess = payload => ({
    type:"GET_LEDGER_SUCCESS",
    payload
})

export const getLedgerFail = payload => ({
    type:"GET_LEDGER_FAIL",
    payload
})

export const getLedgerException = payload => ({
    type:"GET_LEDGER_EXCEPTION",
    payload
})


export const  getLedgerAsync = (data) => async dispatch => {
    dispatch(getLedgerStart())
    try {
        const aData = await getLedger(data)
        if(aData.status){
            dispatch(getLedgerSuccess(aData))
        }
        else
            dispatch(getLedgerFail(aData))

    }catch (e){
        dispatch(getLedgerException(e.message))
    }
};

async function getLedger(data) {
    Api.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("token")}`;
    const resp = await Api.post('ledger-data',data);
    return resp.data
}